/**
 * Two-column layout form (e.g. data-black-market, now-with-thread).
 *
 * The canonical two-col slide is a CSS grid with a left-side narrative
 * "trail" and a right-side image / chart panel. This form keeps the
 * markup as a single bodyHtml field for fidelity and adds layout hints
 * for the panel structure.
 */

import type { Slide, SlideUpdatePayload } from "../types";
import { CommonSlideFields } from "./CommonSlideFields";
import { LayoutHint } from "./LayoutHint";
import { TextArea } from "./FormPrimitives";

interface TwoColFormProps {
  draft: Slide;
  setField<K extends keyof SlideUpdatePayload>(
    key: K,
    value: SlideUpdatePayload[K],
  ): void;
  flush(): void;
}

export function TwoColForm({ draft, setField, flush }: TwoColFormProps) {
  return (
    <div data-testid="layout-form-two-col">
      <LayoutHint title="Two-column slide">
        Outer wrapper is a CSS grid (<code>grid-template-columns: 1fr 1.2fr</code>).
        Left column is the narrative trail (<code>.trail-beat</code> children
        with <code>data-panel</code>). Right column holds the synced image
        panel.
      </LayoutHint>
      <CommonSlideFields draft={draft} setField={setField} flush={flush} />
      <TextArea
        label="Body HTML (full grid markup)"
        value={draft.bodyHtml}
        onChange={(v) => setField("bodyHtml", v)}
        onBlur={flush}
        rows={14}
        testId="slide-body-html-input"
      />
    </div>
  );
}
